import React from 'react';
// TODO: separate ariaLabelledBy from StatusContext, since it's not related to status or reflect expanded StatusContext responsibilities by renaming
export const StatusContext = React.createContext({
    status: null,
    ariaLabelledBy: null,
    ariaDescribedBy: null,
});
export const getStatusFromContext = ({ status }, propsStatus) => propsStatus || status;
export const getAriaAttributesFromContext = ({ ariaLabelledBy, ariaDescribedBy, }) => ({
    ...(ariaLabelledBy && { 'aria-labelledby': ariaLabelledBy }),
    ...(ariaDescribedBy && { 'aria-describedby': ariaDescribedBy }),
});
//# sourceMappingURL=StatusContext.js.map